import { Routes } from '@angular/router';
import { authMatchGuard } from '../auth/guards/auth.guard';

export const inspireRoutes: Routes = [
  {
    path: 'inspiration/list',
    loadComponent: () =>
      import('./pages/inspire/inspire.component').then((m) => m.InspireComponent),
    canMatch: [authMatchGuard],
    title: `Inspiration`,
  },
  // Disabling this route temporary
  // {
  //   path: 'inspire',
  //   loadComponent: () => import('./pages/themes/themes.component').then((m) => m.ThemesComponent),
  //   canMatch: [authMatchGuard],
  //   title: `Themes`,
  // },
  {
    path: 'inspire/create',
    loadComponent: () => import('./pages/create/create.component').then((m) => m.CreateComponent),
    canMatch: [authMatchGuard],
    title: `Create Inspiration`,
  },
  {
    path: 'inspire/:id/:tag',
    loadComponent: () => import('./pages/details/details.page').then((m) => m.DetailsPage),
    canMatch: [authMatchGuard],
    title: `Inspiration details`,
  },
  {
    path: 'old-map',
    loadComponent: () =>
      import('./pages/map-details/map-details.page').then((m) => m.MapDetailsPage),
    canMatch: [authMatchGuard],
    title: `Inspiration details`,
  },
  {
    path: 'old-map/:id',
    loadComponent: () =>
      import('./pages/map-details/map-details.page').then((m) => m.MapDetailsPage),
    canMatch: [authMatchGuard],
    title: `Inspiration details`,
  },
  {
    path: 'video/:id',
    loadComponent: () => import('./pages/video/video.page').then((m) => m.VideoPage),
    title: `Your video details`,
  },
  {
    path: 'map/:id',
    loadComponent: () => import('./pages/shared/shared.page').then((m) => m.SharedInspirationPage),
    title: `Your video details`,
  }
] as Routes;
